import map from 'lodash/map'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { BoardCheckbox } from './BoardCheckbox'
import { useContext } from './Context'
import { CreateNewBoardButton } from './CreateNewBoardButton'
import { SaveCancelBoardItemButton } from './SaveCancelBoardItemButton'

export const AddItemModalContent = () => {
  const { selectedBoard } = useContext()

  return (
    <div className="flex-column d-flex justify-content-between   h-100 ">
      <div>
        <h3 className="text-center  ">Save your item to a favorite and stay organized!</h3>
        <div className="small text-center">Choose which favorite you want to add this item</div>
        <hr />
        <Row>
          {map(selectedBoard, (item) => (
            <Col lg={6} key={item?._id}>
              <BoardCheckbox {...item} />
            </Col>
          ))}
        </Row>
      </div>
      <div>
        <hr />
        <div className="d-flex justify-content-between   mt-4 ">
          <CreateNewBoardButton />
          <SaveCancelBoardItemButton />
        </div>
      </div>
    </div>
  )
}
